import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/GetHistogramConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var moment = require('moment');
var _ = require("lodash");
var organization, country, locality, area, profile, granularity = 'weekly';
var dateRange = {}, filters = {}, graphType;

var DateWiseReviewHistoAction = function () {

}

DateWiseReviewHistoAction.prototype = {

	addFilters: function (data, newGranularity) {
		filters = data;
		granularity = newGranularity;
		this.loadData();
	},

	clearFilters: function () {
		filters = {};
		granularity = 'weekly';
	},

	changeProfile: function (value) {
		profile = value;
		this.loadData();
	},

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
	},

	addDownloadFilters: function (data) {
		filters = _.cloneDeep(data);
		if (filters.profileId) {
			// profileId = filters.profileId;
			delete filters.profileId
		}

		if (data.granularity) {
			granularity = data.granularity;
			// delete data.granularity;
		}
		this.loadData();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData()
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData();
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
	},

	changeGranularity: function (value) {
		granularity = value;
		this.loadData();
	},

	loadData: function () {

		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			sources: filters.sources != null ? filters.sources : [],
			filters: filters,
			graphType: ["dayOfWeek", "dayOfMonth", "monthOfYear"],
		};


		restClient.getReviewHistogram(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.GET_DATEWISE_HISTOGRAM,
					data: response
				});
			}
		})
	}
}

export default new DateWiseReviewHistoAction();